// src/helpers/factories/settings/usersFactory.ts
var BEHAVIOR_ON_NEW_ORDER_OPTIONS = {
  1: "enter_order" /* ENTER_ORDER */,
  2: "stay_in_table_layout" /* STAY_IN_TABLE_LAYOUT */
};
var ROLE_DEFAULT_MODULE_OPTIONS = {
  1: "homeModule" /* HOME_MODULE */,
  2: "menuModule" /* MENU_MODULE */,
  3: "registerModule" /* REGISTER_MODULE */,
  4: "managementModule" /* MANAGEMENT_MODULE */,
  5: "reportsModule" /* REPORTS_MODULE */,
  6: "settingsModule" /* SETTINGS_MODULE */,
  7: "customersModule" /* CUSTOMERS_MODULE */
};
var behaviorOnNewOrderFactory = (t) => Object.values(BEHAVIOR_ON_NEW_ORDER_OPTIONS).map((option, index) => ({
  label: t(
    `settingsModule.roleDetailsSettings.register.behaviorOnNewOrder.options.${option}`
  ),
  value: index + 1
}));
var roleDefaultModuleFactory = (t, homeScreenPermissions) => Object.values(ROLE_DEFAULT_MODULE_OPTIONS).map((field, index) => {
  const isDisabled = field === "homeModule" /* HOME_MODULE */ ? false : !homeScreenPermissions[`${field}Available`];
  return {
    label: `${t(
      `settingsModule.roleDetailsSettings.home.homeScreenDefaultModules.modules.${field}Default`
    )}${isDisabled ? ` (${t(
      "settingsModule.roleDetailsSettings.home.homeScreenDefaultModules.noAccess"
    )})` : ""}`,
    value: index + 1,
    isDisabled
  };
});

export { BEHAVIOR_ON_NEW_ORDER_OPTIONS, ROLE_DEFAULT_MODULE_OPTIONS, behaviorOnNewOrderFactory, roleDefaultModuleFactory };
